module.exports = __webpack_public_path__ + "img/null_pg.f69ccfae.jpg";